import { OuiButtonToggleOption } from 'omnium-ui/button-toggle';

export type Civilite = 'MR' | 'MME';

export const civiliteOptions: OuiButtonToggleOption<Civilite>[] = [
  { value: 'MR', label: 'Monsieur' },
  { value: 'MME', label: 'Madame' },
];
